module.exports = __webpack_public_path__ + "static/media/Home.spec.22d66812.js";


//////////////////
// WEBPACK FOOTER
// ./src/pages/home/__specs__/Home.spec.js
// module id = 106
// module chunks = 4